// modules/Title/TitleMenu.js
// 标题场景菜单模块

import UIStyleHelper from '../UIStyleHelper.js';

export default class TitleMenu {
    constructor(scene) {
        this.scene = scene;
        this.menuItems = ['单人游戏', '多人游戏', '游戏设置', '退出游戏'];
        this.menuTexts = [];
        this.selectedMenuItem = 0;
        this.indicator = null;
    }
    
    /**
     * 创建菜单
     */
    create() {
        // 创建菜单容器
        const menuY = this.scene.cameras.main.centerY + 50;
        
        this.menuTexts = [];
        this.menuItems.forEach((item, index) => {
            // 使用UIStyleHelper创建菜单项
            const text = UIStyleHelper.createMenuItem(
                this.scene,
                item,
                this.scene.cameras.main.centerX,
                menuY + (index * 40),
                index === this.selectedMenuItem
            );
            
            // 添加点击事件
            text.on('pointerdown', () => {
                this.onMenuItemClick?.(index);
            });
            
            // 添加悬停效果
            text.on('pointerover', () => {
                this.selectedMenuItem = index;
                this.updateMenuSelection();
            });
            
            this.menuTexts.push(text);
        });
        
        // 添加选择指示器（使用UIStyleHelper）
        this.indicator = UIStyleHelper.createText(
            this.scene,
            '▶',
            this.scene.cameras.main.centerX - 100,
            menuY,
            UIStyleHelper.getStyle('HIGHLIGHT')
        );
    }
    
    /**
     * 更新菜单选择状态
     */
    updateMenuSelection() {
        // 更新菜单选择状态
        this.menuTexts.forEach((text, index) => {
            text.setStyle({
                fill: index === this.selectedMenuItem ? '#ffff00' : '#ffffff'
            });
        });
        
        // 更新指示器位置
        if (this.indicator && this.menuTexts[this.selectedMenuItem]) {
            this.indicator.y = this.menuTexts[this.selectedMenuItem].y;
        }
    }
    
    /**
     * 移动选择
     * @param {number} direction - 方向 (-1 上, 1 下)
     */
    moveSelection(direction) {
        this.selectedMenuItem = (this.selectedMenuItem + direction + this.menuItems.length) % this.menuItems.length;
        this.updateMenuSelection();
    }
    
    /**
     * 获取选中的菜单项索引
     * @returns {number} 选中的菜单项索引
     */
    getSelectedMenuItem() {
        return this.selectedMenuItem;
    }
    
    /**
     * 设置菜单项点击回调
     * @param {Function} callback - 回调函数 (index) => void
     */
    setMenuItemClickCallback(callback) {
        this.onMenuItemClick = callback;
    }
    
    /**
     * 销毁菜单
     */
    destroy() {
        this.menuTexts.forEach(text => {
            if (text && text.destroy) text.destroy();
        });
        this.menuTexts = [];
        
        if (this.indicator && this.indicator.destroy) {
            this.indicator.destroy();
            this.indicator = null;
        }
    }
}

